import api from "./api";

export const USER = "@userinfo";

// Id da filial do usuário logado, usado nas rotas /send-nf/:id.
export const getSubsidiaryId = () => {
  try {
    const user = JSON.parse(localStorage.getItem(USER));

    // O @userinfo guarda o id no topo; os demais caminhos cobrem sessões
    // antigas/outros formatos para a chamada não ser silenciosamente pulada.
    const id =
      user?.agro_subsidiary_id ||
      user?.agro_subsidiaries?.id ||
      user?.contrato?.company?.agro_subsidiary_id ||
      null;

    if (!id) {
      console.error("send-nf: agro_subsidiary_id não encontrado no @userinfo", user);
    }

    return id;
  } catch (e) {
    console.error("send-nf: falha ao ler o @userinfo do localStorage", e);
    return null;
  }
};

/**
 * Status de envio de NF da filial (agro_subsidiaries.envio_nf).
 * Devolve 0 ou 1; null quando não foi possível saber.
 */
export const getSendNfStatus = async () => {
  const subsidiaryId = getSubsidiaryId();
  if (!subsidiaryId) return null;

  try {
    const response = await api.get(`/send-nf/${subsidiaryId}`);
    const nf = Number(response?.data?.data?.nf);

    if (nf === 0 || nf === 1) return nf;

    console.error("send-nf: resposta fora do contrato", response?.data);
    return null;
  } catch (error) {
    console.error(
      `Falha ao consultar /send-nf/${subsidiaryId}`,
      error?.response?.status,
      error?.response?.data
    );
    return null;
  }
};

// O histórico monta um badge por receita, e cada um precisa saber se a filial
// envia NF. Sem esse cache seriam dezenas de GET /send-nf iguais por tela.
let statusEmCache = null;

/**
 * Igual ao getSendNfStatus, mas com uma única requisição por sessão.
 * A promessa é guardada (não o valor) para chamadas simultâneas — o caso da
 * lista do histórico — esperarem a mesma ida ao servidor.
 */
export const getSendNfStatusCached = () => {
  if (!statusEmCache) {
    statusEmCache = getSendNfStatus().then((nf) => {
      // Falha ou resposta fora do contrato não vira cache: na próxima tela
      // vale tentar de novo, em vez de carregar um null para sempre.
      if (nf !== 0 && nf !== 1) statusEmCache = null;
      return nf;
    });
  }

  return statusEmCache;
};

/** Esquece o valor lido, para a próxima consulta ir ao servidor. */
export const resetSendNfStatusCache = () => {
  statusEmCache = null;
};

/**
 * Grava o status de envio de NF da filial.
 * @param {number} nf 1 = envia NF (toggle desligado), 0 = não envia (toggle ligado)
 * @returns o valor gravado (0 ou 1); null em caso de falha
 */
export const putSendNfStatus = async (nf) => {
  const subsidiaryId = getSubsidiaryId();
  if (!subsidiaryId) return null;

  const response = await api.put(`/send-nf/${subsidiaryId}`, { nf });
  const saved = Number(response?.data?.data?.nf);

  // O toggle acabou de mudar o que o histórico precisa saber: o cache passa a
  // valer o valor gravado, sem esperar um reload.
  if (saved === 0 || saved === 1) {
    statusEmCache = Promise.resolve(saved);
    return saved;
  }

  resetSendNfStatusCache();
  return null;
};
